import { useState, useEffect, useCallback } from 'react';
var API = 'https://api.algrok.com';
function fmtRs(n){if(n==null||isNaN(n))return'--';var a=Math.abs(Math.round(n));return(n>=0?'+':'-')+a.toLocaleString('en-IN')+'\u20B9';}

export default function QuantiplyM(){
  var [algos,setAlgos]=useState([]);
  var [expanded,setExpanded]=useState(null);
  var [logAlgo,setLogAlgo]=useState(null);

  var fetchState=useCallback(function(){
    fetch(API+'/algos').then(function(r){return r.json();}).then(function(d){
      var list=Array.isArray(d)?d:(d.algos||[]);
      setAlgos(list);
    }).catch(function(){});
  },[]);
  useEffect(function(){fetchState();var id=setInterval(fetchState,3000);return function(){clearInterval(id);};},[fetchState]);

  var doApi=function(url,body){
    fetch(API+url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body||{})}).then(function(){fetchState();}).catch(function(){});
  };

  var G='#00d4aa',R='#ff4466',Y='#fbbf24',M='#4a5c72',T='#e2e8f0',BD='rgba(26,45,74,0.35)',CD='rgba(12,18,32,0.95)';
  var totalPnl=algos.reduce(function(sum,a){return sum+(a.mtm||0);},0);
  var LOT_SIZES={NIFTY:75,BANKNIFTY:75,FINNIFTY:40,SENSEX:10};

  return(
  <div style={{minHeight:'100vh',background:'#05080f',color:T,fontFamily:"system-ui,sans-serif",paddingTop:'env(safe-area-inset-top,0)',paddingBottom:70,overflowX:'hidden'}}>
    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'14px 16px 10px',borderBottom:'1px solid '+BD}}>
      <span style={{fontSize:15,fontWeight:800}}>Quantiply</span>
      <span style={{fontSize:10,color:M}}>{algos.length} algos</span>
    </div>
    <div style={{textAlign:'center',padding:'16px 16px 12px'}}>
      <div style={{fontSize:11,color:M,fontWeight:700,textTransform:'uppercase',marginBottom:4}}>Today's total</div>
      <div style={{fontSize:34,fontWeight:900,color:totalPnl>=0?G:R,letterSpacing:'-2px',lineHeight:1}}>{fmtRs(totalPnl)}</div>
    </div>

    {algos.map(function(algo){
      var isExp=expanded===algo.id;
      var mtm=algo.mtm||0;
      var legs=algo.legs_detail||[];
      var openLegs=legs.filter(function(l){return l.status==='open';});
      var closedLegs=legs.filter(function(l){return l.status!=='open'&&l.status!=='pending';});
      var status=algo.status;
      var isActive=status==='trade_active';
      var isClosed=status==='trade_closed';
      var isDisabled=status==='disabled';
      var isReady=status==='ready'||status==='entering'||status==='enabled';
      var statusLabel=isActive?'ACTIVE':isClosed?'CLOSED':isReady?'READY':isDisabled?'DISABLED':status;
      var statusColor=isActive?G:isClosed?(mtm>=0?G:Y):isReady?Y:M;
      var events=algo.events||[];
      var cfg=algo.config||{};
      var mult=algo.multiplier||1;
      // NRML carries overnight — worth showing on the phone, where this is
      // often the only view. Settings stay on desktop, as with the Walls.
      var prod=(algo.product||cfg.product)==='NRML'?'NRML':'MIS';
      var idx=cfg.index||'NIFTY';
      var lotSize=LOT_SIZES[idx]||75;
      var totalQty=mult*lotSize;
      var borderColor=isExp?'rgba(14,165,233,0.3)':isDisabled?'rgba(26,45,74,0.2)':BD;

      return <div key={algo.id} style={{margin:'0 12px 8px',background:CD,borderRadius:14,border:'1px solid '+borderColor,overflow:'hidden'}}>
        <div onClick={function(){setExpanded(isExp?null:algo.id);}} style={{padding:'12px 16px',display:'flex',alignItems:'center',justifyContent:'space-between',borderBottom:isExp?'1px solid rgba(26,45,74,0.2)':'none'}}>
          <div style={{display:'flex',alignItems:'center',gap:10}}>
            <div style={{width:6,height:32,borderRadius:3,background:isDisabled?M:mtm>=0?G:R}}/>
            <div>
              <div style={{fontSize:13,fontWeight:800,color:isDisabled?'#8899aa':T}}>{algo.name||algo.id}</div>
              <div style={{fontSize:9,color:M,marginTop:1}}>
                {idx} · {mult}x · {legs.length} legs
                {prod === 'NRML' ? <span style={{color:Y,fontWeight:800}}> · NRML</span> : ' · MIS'}
              </div>
            </div>
          </div>
          <div style={{display:'flex',alignItems:'center',gap:10}}>
            <div style={{textAlign:'right'}}>
              <div style={{fontSize:16,fontWeight:900,color:isDisabled?M:mtm>=0?G:R}}>{isDisabled?'--':fmtRs(mtm)}</div>
              <div style={{fontSize:8,color:statusColor}}>{statusLabel}{isClosed&&mtm>0?' \u2713':''}</div>
            </div>
            <span style={{fontSize:14,color:M,transform:isExp?'rotate(90deg)':'none',transition:'transform 0.2s',display:'inline-block'}}>{'\u203A'}</span>
          </div>
        </div>

        {isExp&&<div style={{padding:'10px 16px'}}>
          {!isDisabled&&<div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:6,marginBottom:10}}>
            <div style={{background:'rgba(0,0,0,0.25)',borderRadius:8,padding:'6px 8px'}}>
              <div style={{fontSize:7,color:M,fontWeight:700,textTransform:'uppercase'}}>MTM</div>
              <div style={{fontSize:13,fontWeight:800,color:mtm>=0?G:R}}>{fmtRs(mtm)}</div>
            </div>
            <div style={{background:'rgba(0,0,0,0.25)',borderRadius:8,padding:'6px 8px'}}>
              <div style={{fontSize:7,color:M,fontWeight:700,textTransform:'uppercase'}}>SL / TGT</div>
              <div style={{fontSize:13,fontWeight:800}}>{algo.sl_value?Math.round(algo.sl_value):'--'} / {algo.target_value?Math.round(algo.target_value):'--'}</div>
            </div>
            <div style={{background:'rgba(0,0,0,0.25)',borderRadius:8,padding:'6px 8px'}}>
              <div style={{fontSize:7,color:M,fontWeight:700,textTransform:'uppercase'}}>Entry</div>
              <div style={{fontSize:13,fontWeight:800}}>{algo.start_time||algo.entry_time||'--'}</div>
            </div>
          </div>}

          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:10,padding:'8px 10px',background:'rgba(0,0,0,0.2)',borderRadius:10}}>
            <span style={{fontSize:10,color:M,fontWeight:700}}>MULTIPLIER</span>
            <div style={{display:'flex',alignItems:'center'}}>
              <div onClick={function(e){e.stopPropagation();doApi('/algo/'+algo.id+'/set-schedule',{multiplier:Math.max(1,mult-1)});}} style={{width:34,height:32,borderRadius:'8px 0 0 8px',border:'1px solid '+BD,background:'rgba(0,0,0,0.3)',color:T,fontSize:16,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center'}}>-</div>
              <div style={{width:44,height:32,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(0,0,0,0.5)',borderTop:'1px solid '+BD,borderBottom:'1px solid '+BD,fontSize:15,fontWeight:900}}>{mult}x</div>
              <div onClick={function(e){e.stopPropagation();doApi('/algo/'+algo.id+'/set-schedule',{multiplier:mult+1});}} style={{width:34,height:32,borderRadius:'0 8px 8px 0',border:'1px solid '+BD,background:'rgba(0,0,0,0.3)',color:T,fontSize:16,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center'}}>+</div>
              <div style={{fontSize:9,color:M,marginLeft:8}}>= {totalQty} qty</div>
            </div>
          </div>

          {openLegs.length>0&&<div style={{marginBottom:10}}>
            <div style={{fontSize:8,color:M,fontWeight:700,textTransform:'uppercase',marginBottom:4}}>Open legs</div>
            {openLegs.map(function(l,i){
              var lPnl=l.pnl||0;
              var entry=l.avg_entry||l.entry_price||0;
              return <div key={'o'+i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'5px 0',borderBottom:i<openLegs.length-1?'1px solid rgba(26,45,74,0.12)':'none'}}>
                <div style={{display:'flex',alignItems:'center',gap:6}}>
                  <span style={{fontSize:11,fontWeight:700}}>{l.strike} {l.option_type||l.type}</span>
                  <span style={{fontSize:9,color:(l.buy_sell||l.side)==='BUY'?G:R}}>{l.buy_sell||l.side}</span>
                  {entry>0&&<span style={{fontSize:9,color:M}}>@{typeof entry==='number'?entry.toFixed(1):entry}</span>}
                </div>
                <span style={{fontSize:11,fontWeight:700,color:lPnl>=0?G:R}}>{fmtRs(lPnl)}</span>
              </div>;
            })}
          </div>}

          {closedLegs.length>0&&<div style={{marginBottom:10}}>
            <div style={{fontSize:8,color:M,fontWeight:700,textTransform:'uppercase',marginBottom:4}}>Closed legs</div>
            {closedLegs.map(function(l,i){
              var lPnl=l.pnl||0;
              var entry=l.avg_entry||l.entry_price||0;
              var exit=l.exit_price||0;
              return <div key={'c'+i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'5px 0',borderBottom:i<closedLegs.length-1?'1px solid rgba(26,45,74,0.12)':'none',opacity:0.7}}>
                <div style={{display:'flex',alignItems:'center',gap:6}}>
                  <span style={{fontSize:11,fontWeight:700}}>{l.strike} {l.option_type||l.type}</span>
                  <span style={{fontSize:9,color:(l.buy_sell||l.side)==='BUY'?G:R}}>{l.buy_sell||l.side}</span>
                  {entry>0&&<span style={{fontSize:9,color:M}}>@{typeof entry==='number'?entry.toFixed(1):entry}</span>}
                  {exit>0&&<span style={{fontSize:9,color:M}}>{'\u2192'}{typeof exit==='number'?exit.toFixed(1):exit}</span>}
                </div>
                <span style={{fontSize:11,fontWeight:700,color:lPnl>=0?G:R}}>{fmtRs(lPnl)}</span>
              </div>;
            })}
          </div>}

          {(isActive||isReady)&&<div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:6,marginBottom:8}}>
            <div onClick={function(){doApi('/algo/'+algo.id+'/enter');}} style={{padding:10,borderRadius:10,border:'1px solid rgba(14,165,233,0.3)',background:'rgba(14,165,233,0.06)',color:'#0ea5e9',fontSize:11,fontWeight:800,textAlign:'center'}}>Re-enter</div>
            <div onClick={function(){if(window.confirm('Exit '+(algo.name||algo.id)+'?'))doApi('/algo/'+algo.id+'/exit',{reason:'Manual'});}} style={{padding:10,borderRadius:10,border:'1px solid '+R+'30',background:R+'06',color:R,fontSize:11,fontWeight:800,textAlign:'center'}}>Exit</div>
            <div onClick={function(){setLogAlgo(logAlgo===algo.id?null:algo.id);}} style={{padding:10,borderRadius:10,border:'1px solid '+BD,background:'rgba(0,0,0,0.2)',color:'#8899aa',fontSize:11,fontWeight:800,textAlign:'center'}}>Logs</div>
          </div>}

          {isClosed&&<div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:6,marginBottom:8}}>
            <div onClick={function(){doApi('/algo/'+algo.id+'/enter');}} style={{padding:10,borderRadius:10,border:'1px solid rgba(14,165,233,0.3)',background:'rgba(14,165,233,0.06)',color:'#0ea5e9',fontSize:11,fontWeight:800,textAlign:'center'}}>Re-enter</div>
            <div onClick={function(){setLogAlgo(logAlgo===algo.id?null:algo.id);}} style={{padding:10,borderRadius:10,border:'1px solid '+BD,background:'rgba(0,0,0,0.2)',color:'#8899aa',fontSize:11,fontWeight:800,textAlign:'center'}}>Logs</div>
          </div>}

          {isDisabled&&<div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:6,marginBottom:8}}>
            <div onClick={function(){doApi('/algo/'+algo.id+'/enable');}} style={{padding:10,borderRadius:10,border:'1px solid rgba(0,212,170,0.3)',background:'rgba(0,212,170,0.06)',color:G,fontSize:11,fontWeight:800,textAlign:'center'}}>Enable</div>
            <div onClick={function(){setLogAlgo(logAlgo===algo.id?null:algo.id);}} style={{padding:10,borderRadius:10,border:'1px solid '+BD,background:'rgba(0,0,0,0.2)',color:'#8899aa',fontSize:11,fontWeight:800,textAlign:'center'}}>Logs</div>
          </div>}

          {logAlgo===algo.id&&events.length>0&&<div style={{marginTop:4,background:'rgba(0,0,0,0.3)',borderRadius:10,padding:'8px 10px',maxHeight:180,overflowY:'auto'}}>
            {events.slice().reverse().slice(0,20).map(function(e,i){
              var c=e.type==='success'?G:e.type==='error'?R:e.type==='warning'?Y:M;
              return <div key={i} style={{fontSize:10,color:c,padding:'3px 0',borderBottom:'1px solid rgba(26,45,74,0.1)',fontFamily:'monospace'}}>
                <span style={{color:M,marginRight:6}}>{e.ts||e.time||''}</span>{e.msg||e.message||''}
              </div>;
            })}
          </div>}
        </div>}
      </div>;
    })}

    {algos.length===0&&<div style={{textAlign:'center',color:M,padding:40,fontSize:12}}>No algos configured</div>}
  </div>);
}
